import React from 'react';
import { NavigationReducerDataFilterTags } from '../../../../Redux/Reducers/NavigationReducer';
import { useAppSelector } from '../../../../Redux/Store/hooks';
import { CollectionFilter } from '../../../Data/CollectionFilter';
import { DropdownComponent } from '../Generic/DropdownComponent';

type FilterComponentParameters = {
  filters : Array<CollectionFilter>,
  filterSelection : NavigationReducerDataFilterTags[] | undefined,
  selectFilterHandler : (filterType: string, filterValue: string) => void
};

export function FilterComponent({
  filters,
  filterSelection,
  selectFilterHandler,
} : FilterComponentParameters) {

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  const renderOption = (filter : CollectionFilter, id : number) => {
    // We need to know if there's an option to select already

    let optionInitialValue : string = '';

    if (filterSelection) {
      const optionName = filter.name;

      const initialOptionSelection = filterSelection.find(
        (filterSelectionOption) => {
          return filterSelectionOption.type === optionName;
        },
      );

      if (initialOptionSelection) {
        optionInitialValue = initialOptionSelection.value;
      }
    }

    return (
      <div className="row" key={id} style={{ display: 'block' }}>
        <DropdownComponent
          title={filter.name}
          id={id.toString()}
          options={filter.options}
          selectedOption={optionInitialValue}
          onSelectHandler={(value) => { selectFilterHandler(value, id.toString()); }}
          key={id}
        />
      </div>
    );
  };

  return (
    <div className="container">
      {filters && (
        <div className="col">
          <div className="row" style={{ padding: '10px 0 20px 0' }}>
            <h2>{strings.FILTERS_LABEL}</h2>
          </div>
          {filters.map((filter, id) => renderOption(filter, id))}
        </div>
      )}
    </div>
  );
}
